import React from 'react';
import PropTypes from 'prop-types';
import Filters from './Filters.jsx';
import Tools from './Tools.jsx'

function Toolbar({
  filterProps,
  toolsProps,
  groupId,
}) {
  return (
    <div>
      <Filters {...filterProps} />
      <Tools {...toolsProps} groupId={groupId} />
    </div>
  );
}

Toolbar.defaultProps = {};

Toolbar.propTypes = {
  filterProps: PropTypes.object,
  toolsProps: PropTypes.object
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Webinar/Toolbar/index.jsx